import {
    CALL_CUSTOM_VARS_LIST_PARAMETER_NAME,
    CLIENT_PHONE_PARAMETER_NAME,
    EMOTION_LIST_PARAMETER_NAME
} from '@/enum/widgetTemplateConfigs.js'

/**
 * Entity Multi-Select that provides JSON with Positive/Negative arrays
 *
 * @type {number}
 */
export const MULTI_SELECT_PARAMETER_TYPE_ID = 6
/**
 * Identical to Multi-Select (6),
 * the only difference between 6 and 17 is that for 6 we have the back-end logic for permission validation of the data,
 * and not all the entities needs that so that's why 17 even exist 🫠
 * @type {number}
 */
export const MULTI_SELECT_NOT_VALIDATED_PARAMETER_TYPE_ID = 17
/**
 * AI Summary CDR Template Parameter Type
 * Used for Summary_CDR_Template parameter with single/multiple/template options
 * @type {number}
 */
export const AI_SUMMARY_CDR_TEMPLATE_PARAMETER_TYPE_ID = 20

export default {
    EXTENSION_ID: 188,
    AUTO_COMPLETE_TYPE_KEYS: [ MULTI_SELECT_PARAMETER_TYPE_ID, MULTI_SELECT_NOT_VALIDATED_PARAMETER_TYPE_ID ],
    NOT_TREE_PARAMETER_NAMES: [ EMOTION_LIST_PARAMETER_NAME, CLIENT_PHONE_PARAMETER_NAME, CALL_CUSTOM_VARS_LIST_PARAMETER_NAME ],
    MULTISELECT_TYPE_KEYS: [ 16 ],
    MULTISELECT_EXTENDED: [ 18 ],
    PROMPTS_MODAL_TABS: [ 19 ],
    AI_SUMMARY_CDR_TEMPLATE: [ AI_SUMMARY_CDR_TEMPLATE_PARAMETER_TYPE_ID ]
}
